import "./login-page.css";
import {
  React,
  Link,
  useNavigate,
  useRef,
  useEffect,
  Button,
  DigitalSignage,
  toast,
  useState,
  LoadingSpinner,
  Password,
  InputText,
  capturepageanalytics,
  SetCookie,
  RemoveCookie,
  useGoogleLogin,
  axios,
  GoogleIcon,
  Avatar,
  useLocation,
  cryptoRandomString,
  useMainAuthMutation,
} from "../../../Libraries/Authentication/Login/index";
import { captureeventbaseanalytics } from "../../../Analytics/Google/AllAnalytics/Capturing";

import BoostBoardLogo from '../../../Assets/svgs/boostboard_logo.svg';
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const username = useRef();

  const [password, setpassword] = useState("");
  const [loginObj, { isLoading }] = useMainAuthMutation();

  useEffect(() => {
    capturepageanalytics(window.location.pathname);
  }, [location]);

  const handleManualLogin = async (e) => {
    e.preventDefault();
    if (
      username.current.value === "" ||
      username.current.value === null ||
      username.current.value === undefined ||
      username.current.value === "null" ||
      username.current.value === "undefined"
    ) {
      toast.error("Username is empty");
      captureeventbaseanalytics("Customer Login", "Login", "Username is empty");
      username.current.focus();
    } else if (
      password === "" ||
      password === null ||
      password === undefined ||
      password === "null" ||
      password === "undefined"
    ) {
      toast.error("Password is empty");
      captureeventbaseanalytics("Customer Login", "Login", "Password is empty");
    } else {
      const logindata = new FormData();
      logindata.append("txt_customer_id", username.current.value);
      logindata.append("txt_customer_password", btoa(password));
      /** modified by maheen for api shifting **/
      const session_id = cryptoRandomString({ length: 20, type: "url-safe" })
      logindata.append("session_id", session_id);
      SetCookie('session_id', session_id)
      /*** */
 
      logindata.append("function", "MANUAL_LOGIN");
      try {
        const data = await loginObj(logindata).unwrap();
        if (
          data.connection === "true" &&
          data.status === "true" &&
          data.message === "Login Success"
        ) {
          captureeventbaseanalytics(
            "Authentication",
            "BoostBoard_Login",
            data.message
          );
          toast.success(data.message);
          RemoveCookie("es_token");
          RemoveCookie("is_first_time_login");
          SetCookie("es_token", data.data.es_token);
          SetCookie("is_first_time_login", data.data.is_first_time_login);
          localStorage.setItem("txt_customer_id", data.data.USERID);
          navigate("/dashboard");
        } else {
          captureeventbaseanalytics(
            "Authentication",
            "BoostBoard_Login",
            data.message
          );
          toast.error(data.message);
          console.log(data);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.error);
      }
    }
  };

  const handleLoginViaGoogleAfterGoogleAuth = async (userinfo, token) => {
  const createCustomer = new FormData();
  createCustomer.append("txt_customer_email", userinfo.email);
  createCustomer.append("gmail_sub", userinfo.sub);
  createCustomer.append("gmail_access_token", token);
  createCustomer.append("function", "LOGIN_WITH_GOOGLE");

  try {
    const data = await loginObj(createCustomer).unwrap();

    if (
      data.status === "true" &&
      data.message === "Login Success" &&
      data.connection === "true"
    ) {
      captureeventbaseanalytics(
        "Authentication",
        "BoostBoard_ContinuewithGoogle",
        data.message
      );
      toast.success(data.message);
      
      RemoveCookie("es_token");
      SetCookie("es_token", data.data.es_token);

      // NEW: Set another cookie for Google login/session
      const session_id = cryptoRandomString({ length: 20, type: "url-safe" })
      SetCookie('session_id', session_id)

      localStorage.setItem("txt_customer_id", data.data.USERID);
      navigate("/dashboard");
    } else {
      toast.error(data.message);
      captureeventbaseanalytics(
        "Authentication",
        "BoostBoard_ContinuewithGoogle",
        data.message
      );
    }
  } catch (error) {
    toast.error(error.error);
    console.log(error);
  }
};


  const LoginUserFromGoogle = async (res) => {
    const userInfo = await axios
      .get("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: { Authorization: `Bearer ${res.access_token}` },
      })
      .then((res) => res.data);
    if (userInfo.email_verified === true && userInfo.email !== "") {
      handleLoginViaGoogleAfterGoogleAuth(userInfo, res.access_token);
    }
  };

  const onFailure = (err) => {
    console.log("failed:", err);
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: LoginUserFromGoogle,
    onError: (error) => onFailure(error),
  });

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <div
        className="bg_lp"
        style={{
          backgroundImage: `url(${"https://bbapi.nayatel.com/api/api/web/AuthBackgroundImage/authbg.png"}), url(${require("../../../Assets/Images/authbg.png")})`,
        }}
      >
        <div className="card_wrapper_lp">
          <div className="shadow rowdesign">
            <div className="auth_logo_login">
              <img src={BoostBoardLogo} alt="logo" width="170px" />
            </div>
            <form className="loginform" onSubmit={handleManualLogin}>
              <div className="row inputfields">
                <div className="col-md-12 col-lg-12 col-sm-12 label_login">
                  <label className="label_login">Username</label>
                  <InputText
                    autoComplete="off"
                    placeholder="Username"
                    className="p-inputtext-sm block mb-1 w-100"
                    ref={username}
                  />
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 mt-1">
                  <label className="label_login">Password</label>
                  <Password
                    className="p-inputtext-sm block w-100"
                    placeholder="Password"
                    feedback={false}
                    autoComplete="off"
                    value={password}
                    name="Password"
                    onChange={(e) => setpassword(e.target.value)}
                    toggleMask
                  />
                </div>
              </div>

              <div className="forgetpwdlink">
                <Link to="/forgetpassword">Forgot Password?</Link>
              </div>

              <div className="form-group">
                <Button
                  sx={{
                    width: "100%",
                    borderRadius: "8px",
                    mt: "20px",
                  }}
                  className="capitalized fs-14 fw-bold"
                  variant="contained"
                  type="submit"
                >
                  Login
                </Button>
              </div>
            </form>

            <div className="form-group login">
              <div className="or-container">
                <div className="line-separator"></div>{" "}
                <div className="or-label">OR</div>
                <div className="line-separator"></div>
              </div>
            </div>

            <div className="form-group mt-2">
              <Button
                onClick={handleGoogleLogin}
                startIcon={
                  <Avatar
                    src={GoogleIcon}
                    sx={{ width: "15px", height: "15px" }}
                  />
                }
                variant="outlined"
                sx={{
                  width: "100%",
                  borderRadius: "8px",
                  textTransform: "none",
                }}
              >
                Continue with Google
              </Button>
            </div>

            <div className="logintosignup">
              <span className="donthaveanacc">Don’t have account? &nbsp;</span>
              <Link
                to="/signup"
                style={{ fontWeight: "bold", color: "#1A75E8" }}
              >
                Signup
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
